import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: 'Emily Roberts',
        title: 'Event Manager',
        biography: "Emily Roberts is a highly experienced event manager with a passion for organizing seamless and engaging events. With expertise in planning, coordination, and logistics, she ensures that every event runs smoothly and exceeds expectations. Her strategic approach and attention to detail make her an invaluable asset in the event industry.",
        contacts: {
            phone: '222-333-4455',
            email: 'emily.roberts@example.com',
            website: 'www.emilyroberts.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            'Successfully organized high-profile corporate events',
            'Expert in venue selection and vendor management',
            'Proven track record in increasing event attendance',
            'Skilled in budget management and cost optimization',
            'Dedicated to delivering unforgettable experiences',
        ],
        skills: [
            { id: 1, title: 'Event Planning', progress: 95 },
            { id: 2, title: 'Team Coordination', progress: 90 },
            { id: 3, title: 'Budget Management', progress: 85 },
        ],
    },
    {
        id: 2, 
        image: images.team2,
        name: 'Michael Smith',
        title: 'Logistics Coordinator',
        biography: "Michael Smith is a highly organized logistics coordinator with extensive experience in managing event logistics, transportation, and on-site operations. His problem-solving skills and efficiency ensure that every aspect of event logistics runs smoothly, from setup to execution.",
        contacts: {
            phone: '333-444-5566',
            email: 'michael.smith@example.com',
            website: 'www.michaelsmith.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            'Successfully coordinated logistics for large-scale events',
            'Expert in transportation and equipment management',
            'Proven ability to handle last-minute event challenges',
            'Ensured seamless event execution with precise scheduling',
            'Strong collaboration with vendors and event teams',
        ],
        skills: [
            { id: 1, title: 'Logistics Management', progress: 95 },
            { id: 2, title: 'Coordination & Planning', progress: 90 },
            { id: 3, title: 'Problem-Solving', progress: 85 },
        ],
    },
    {
        id: 3, 
        image: images.team3,
        name: 'Sarah Lee',
        title: 'Marketing Lead',
        biography: "Sarah Lee is a dynamic marketing lead with a passion for creating impactful event campaigns. With a deep understanding of audience engagement and digital strategies, she ensures maximum event reach and brand visibility.",
        contacts: {
            phone: '555-666-7788',
            email: 'sarah.lee@example.com',
            website: 'www.sarahlee.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            'Developed high-impact marketing campaigns for major events',
            'Expert in social media and digital advertising strategies',
            'Boosted event attendance through innovative outreach',
            'Proven track record in sponsorship and partnership growth',
            'Created engaging content that increased audience interaction',
        ],
        skills: [
            { id: 1, title: 'Digital Marketing', progress: 95 },
            { id: 2, title: 'Brand Strategy', progress: 90 },
            { id: 3, title: 'Social Media Engagement', progress: 85 },
        ],
    },
    {
        id: 4, 
        image: images.team4,
        name: 'John Williams',
        title: 'Technical Director',
        biography: "John Williams is an experienced Technical Director with a strong background in event technology and production. He specializes in ensuring seamless audiovisual setups, live streaming, and technical logistics for large-scale conferences and events.",
        contacts: {
            phone: '444-555-6677',
            email: 'john.williams@example.com',
            website: 'www.johnwilliams.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            'Managed technical setups for high-profile conferences',
            'Expert in audiovisual production and live streaming',
            'Led teams in executing flawless event technology experiences',
            'Innovated new approaches to enhance audience engagement',
            'Ensured seamless integration of event tech solutions',
        ],
        skills: [
            { id: 1, title: 'Event Technology', progress: 95 },
            { id: 2, title: 'Live Streaming', progress: 90 },
            { id: 3, title: 'Technical Logistics', progress: 85 },
        ],
    },
];

export default team;